import { useContext } from "react";
import { useNavManager } from "@hooks";
import { CustomerContractPriceListFormContext } from "../CustomerContractPriceListFormContext";
import { CustomerContractPriceGroupFormData } from "../CustomerContractPriceListFormData";
import { PriceGroupFormLocation } from "../PriceGroupForm/PriceGroupFormLocation";

export type Options = {};

export function useAddNewPriceGroup() {
  const editorStore = useContext(CustomerContractPriceListFormContext);
  const { navManager } = useNavManager();

  const add = () => {
    const group = CustomerContractPriceGroupFormData.CreateEmpty(
      editorStore.highHolidaysOptions,
      editorStore.isBonlivaCare
    );
    editorStore.form.values.priceGroups.push(group);

    navManager.open(
      "new_price_group",
      new PriceGroupFormLocation(
        editorStore.customerContractId,
        editorStore.priceListId,
        group._id,
        editorStore
      )
    );

    navManager.on("close", "new_price_group", () => {
      if (group.records.length === 0) {
        editorStore.form.values.priceGroups.remove(group);
        editorStore.form.validate();
      }
    });
  };

  return { add };
}
